import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import App from "./App";

window.Buffer = Buffer;

const registerKoraxServiceWorker = () => {
  if (
    process.env.NODE_ENV !== "production" ||
    !("serviceWorker" in navigator)
  ) {
    return;
  }

  window.addEventListener("load", async () => {
    try {
      const registration =
        await navigator.serviceWorker.register(
          "/service-worker.js",
          {
            scope: "/"
          }
        );

      console.info(
        "[Korax PWA] Service Worker ativo:",
        registration.scope
      );
    } catch (error) {
      console.warn(
        "[Korax PWA] Falha ao registrar Service Worker:",
        error
      );
    }
  });
};

registerKoraxServiceWorker();

ReactDOM.render(
  <CssBaseline>
    <App />
  </CssBaseline>,
  document.getElementById("root"),
  () => {
    if (typeof window.finishProgress === "function") {
      window.finishProgress();
    }
  }
);
